module.exports = __webpack_public_path__ + "img/img_assistant_phone_img1.40a848b5.png";